import { render } from "./footerComp.vue?vue&type=template&id=1f3aa838&ts=true"
import script from "./footerComp.vue?vue&type=script&lang=ts"
export * from "./footerComp.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__